(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 20394:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(90614);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles_404_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61458);
/* harmony import */ var _styles_404_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_404_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_fonts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(371);
/* harmony import */ var _styles_fonts__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_fonts__WEBPACK_IMPORTED_MODULE_3__);




const ErrorPage = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_404_module_scss__WEBPACK_IMPORTED_MODULE_2___default().errorPage),
        style: (_styles_fonts__WEBPACK_IMPORTED_MODULE_3___default().style),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_404_module_scss__WEBPACK_IMPORTED_MODULE_2___default().imgContainer),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/assets/404.png"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: (_styles_404_module_scss__WEBPACK_IMPORTED_MODULE_2___default().heading),
                children: "Oops"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "You've got a roken link!"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/",
                style: {
                    cursor: "pointer",
                    textDecoration: "none",
                    color: "black",
                    fontWeight: "700"
                },
                className: (_styles_404_module_scss__WEBPACK_IMPORTED_MODULE_2___default().redirectBtn),
                children: "Go back to Home"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ErrorPage);


/***/ }),

/***/ 61458:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"__404_errorPage__i02UE","imgContainer":"__404_imgContainer__DvpAV","heading":"__404_heading__xaxme","redirectBtn":"__404_redirectBtn__X_ici"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,9774,2888,179], function() { return __webpack_exec__(20394); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);